// utils/smartBanner.js
import SmartBanner from 'smart-app-banner';

export const initializeSmartBanner = () => {
  if (typeof window !== 'undefined') {
    new SmartBanner({
      daysHidden: 15,
      daysReminder: 90,
      appStoreLanguage: 'us',
      title: 'WazzaScore',
      author: 'Your Company',
      button: 'VIEW',
      store: {
        ios: 'On the App Store',
        android: 'In Google Play'
      },
      price: {
        ios: 'FREE',
        android: 'FREE'
      }
    });
  }
};
